<template>
  <div class="stock_echart" ref="stock_box"></div>
</template>

<script>
import * as echarts from "echarts";
import mixin from "@/libs/mixin";
export default {
  mixins: [mixin],
  data() {
    return {
      myChart: null,
    };
  },
  mounted() {
    // this.init();
    this.changeView(this.$refs.stock_box, () => {
      if (this.myChart) {
        this.myChart.resize();
      }
    });
  },
  destroyed() {
    window.onresize = null;
  },
  methods: {
    init() {
      this.myChart = echarts.init(this.$refs.stock_box);
    },
    getMin(yData) {
      let arr = yData.map(
        (item) => parseFloat(item.value) || parseFloat(item.value)
      );
      arr.sort();
      return Math.floor(arr[0] * 0.95);
    },
    getMax(yData) {
      let arr = yData.map(
        (item) => parseFloat(item.value) || parseFloat(item.value)
      );
      arr.sort();
      console.log(arr);
      return Math.ceil(arr[arr.length - 1] * 1.05);
    },
    setData(xData, yData) {
      console.log(yData);
      let max = 99999999;
      let min = 0;
      if (yData && yData.length) {
        if (yData && yData.length) {
          max = this.getMax(yData);
          min = this.getMin(yData);
        }
        console.log(max, min);
      }
      this.init();
      this.myChart.setOption({
        grid: {
          left: "2%", // 图表距容器左边的距离
          right: "1%", // 图表距容器右边的距离
          top: "3%", // 图表距容器顶部的距离
          bottom: "3%", // 图表距容器底部的距离
          containLabel: true, // 是否包含坐标轴的刻度标签
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            animation: false,
            type: "cross",
            lineStyle: {
              color: "#376df4",
              width: 1,
              opacity: 1,
            },
          },
          formatter: function (params) {
            let content = "";
            if (params[0]) {
              let data = params[0].data || {};
              content = `DATE:${data.DATE}<br/>Close:${data.Close}
            <br/>High:${data.High}
            <br/>Low:${data.Low}
            <br/>Open:${data.Open}
            <br/>Volume:${data.Volume}
            `;
            }
            return content;
          },
        },
        xAxis: {
          data: xData.reverse(),
          // axisLabel: {
          //   interval: 3, // 设置刻度间隔为0，表示全部显示
          // },
          splitLine: {
            show: false, // 设置为 true 来显示 x 轴的网格线
          },
        },
        dataZoom: [
          {
            type: "inside",
            show: false,
          },
          {
            show: false,
            type: "slider",
            top: "90%",
          },
        ],
        yAxis: {
          axisLine: {
            show: true, // 设置为true来显示y轴轴线
          },
          position: "right", // 设置y轴靠右显示
          max: function (value) {
            console.log(value.max);
            console.log(value.max * 1.05);
            return Math.ceil(value.max * 1.03);
          },
          min: min,
        },
        series: [
          {
            type: "line",
            data: yData.reverse(),
            smooth: false,
            showSymbol: false,
            lineStyle: {
              width: 1,
              color: "#3986BE",
            },
            areaStyle: {
              opacity: 1,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#AEC9E9",
                },

                {
                  offset: 1,
                  color: "rgb(255, 255, 255)",
                },
              ]),
            },
          },
        ],
      });
      this.myChart.resize();
    },
    setOption(xData, yData) {
      let max = 99999999;
      let min = 0;
      if (yData && yData.length) {
        max = this.getMax(yData);
        min = this.getMin(yData);
      }
      console.log(max, min);
      this.myChart.setOption({
        yAxis: {
          axisLine: {
            show: true, // 设置为true来显示y轴轴线
          },
          position: "right", // 设置y轴靠右显示
          max: function (value) {
            console.log(value.max);
            console.log(value.max * 1.05);
            return Math.ceil(value.max * 1.05);
          },
          min: min,
        },
        xAxis: {
          data: xData.reverse(),
          splitLine: {
            show: false, // 设置为 true 来显示 x 轴的网格线
          },
        },
        series: [
          {
            type: "line",
            data: yData.reverse(),
            smooth: false,
            showSymbol: false,
            lineStyle: {
              width: 1,
              color: "#3986BE",
            },
            areaStyle: {
              opacity: 1,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#AEC9E9",
                },

                {
                  offset: 1,
                  color: "rgb(255, 255, 255)",
                },
              ]),
            },
          },
        ],
      });
      this.myChart.dispatchAction({
        type: "dataZoom",
        start: 0,
        end: 100,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.stock_echart {
  width: 100%;
  // height: 400px;
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
}
</style>
